import { environment } from "../../config";
import { iDataEventos } from "../../interfaces/SuperAdmin/Pages/iDataEventos";
import { iDataSublimacion } from "../../interfaces/SuperAdmin/Pages/iDataSublimacion";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getSublimationsByType = (
  id_organizacion?: string,
  id_pais?: string,
  id_usuario?: string
) =>
  fetchData<iDataSublimacion[]>({
    method: "GET",
    url: `${baseApiBroker}/sublimacion-credito`,
    params: {
      ...(id_pais && { id_pais }),
      ...(id_usuario && { id_usuario }),
      ...(id_organizacion && { id_organizacion }),
    },
  });

export const getAuditoriesByType = (
  id_organizacion?: string,
  id_pais?: string,
  id_usuario?: string
) =>
  fetchData<iDataEventos[]>({
    method: "GET",
    url: `${baseApiBroker}/auditoria`,
    params: {
      ...(id_pais && { id_pais }),
      ...(id_usuario && { id_usuario }),
      ...(id_organizacion && { id_organizacion }),
    },
  });
